import { useEffect, useState } from "react";
import { getApiUiUrl } from "@/shared/lib/apiDocsUrl";
import { createMediator } from "@/shared/lib/componentHierarchy";
import {
  useComponentNode,
  useHierarchyLifetime,
} from "@/shared/ui/component-hierarchy/hooks";

type ApiDocsEvent = { type: "root.api-docs-entered" };
export function useApiDocsPresenter(): void {
  const [mediator] = useState(() =>
    createMediator<boolean, ApiDocsEvent, "redirect">(
      false,
      (state) => ({
        status: "handled",
        state: true,
        effects: state ? [] : ["redirect"],
      }),
      { runEffect: () => window.location.replace(getApiUiUrl()) },
    ),
  );
  useHierarchyLifetime(mediator);
  const node = useComponentNode((event) => {
    if (event.type !== "root.api-docs-entered") return "unhandled";
    mediator.dispatch(event as ApiDocsEvent);
    return "handled";
  });
  useEffect(() => {
    node.dispatch({ type: "root.api-docs-entered" });
  }, [node]);
}
